<template>
  <div class="relative h-full w-full">
    <!-- <div id="ChappMap" class="h-full w-full"></div> -->
    <l-map
      ref="map"
      @ready="onReady()"
      class="h-full w-full z-0"
      :zoom="zoom"
      :maxZoom="maxZoom"
      :center="center"
      :options="{zoomControl: false}"
    >
      <!-- <l-geo-json :geojson="geojsonChappultepec" :options-style="styleGeojsonChapp"></l-geo-json> -->
    
<!--     <div style="z-index:10;" class="group flex items-center cursor-pointer" @click="createNew()">
      <div
        v-bind:class="showNoticeModal ? 'bg-red-500 group-hover:bg-cdmx-red' : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
      <svg aria-hidden="true" focusable="false" data-icon="file-alt" class="h-6 w-6 fill-current text-gray-100" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"></path></svg>
      </div>
      <div
        v-bind:class="showNoticeModal ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Nuevo</div>
    </div>   -->  
      <l-tile-layer :url="urlBaseMap" :attribution="attribution"></l-tile-layer>
    </l-map>





    <buttons
      :geometries="geometries"
      @click="imgmap"
      @createNew="createNew()"
      @saved="savedSuccesfully()"
    ></buttons>

    <alert-dialog :showing="askingInfluenceZone">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Qué geometría desea dibujar?</div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-green-500 hover:bg-cdmx-green"
          @click="askingInfluenceZone = false"
        >Marcador Común</button>
        <button
          class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-cdmx-blue-light hover:bg-cdmx-blue-dark"
          @click="askForRadio()"
        >Zona de Influencia</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="askingForRadioValue">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Introduce el valor del radio</div>
      </div>
      <div class="w-full">
          <input
            type="text"
            v-model="radioValue"
            placeholder="Radio en kilometros"
            class="w-full appearance-none border rounded py-2 px-3 mt-2 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
          />
      </div>
      <div class="mt-0 mb-2 w-1/4">
        <small>Kilómetros</small>
      </div>
      <div class="w-full">
        <button
          class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-cdmx-blue-light hover:bg-cdmx-blue-dark"
          @click="createInfluenceZone()"
        >Guardar</button>
        <button
          class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-red-500 hover:bg-cdmx-red"
          @click="askingForRadioValue = false"
        >Cerrar</button>
      </div>
    </alert-dialog>


    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Levantamiento guardado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

  </div>
</template>


<script>
import L from "leaflet";
import { LMap, LGeoJson, LTileLayer } from "vue2-leaflet";
import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
/* import "leaflet.heat"; */
import "leaflet-geometryutil";
import * as esri from "esri-leaflet";
import { stringify } from "wellknown/wellknown.js";

import { backend_url } from "../config/url.config.ts";
import buttons from "./Buttons";
import axios from "axios";
import polygon from "../assets/polygonChapp.json";
import * as turf from '@turf/turf';
import AlertDialog from "./AlertDialog";

export default {
  name: "Map",
  data: function() {
    return {
       showNoticeModal: false,
      updateCluster: true,
      zoom: 9,
      maxZoom: 19,
      //center: [19.412257, -99.200871],
      center: [20.586510, -89.015010],
      map: null,
      //heat: null,
      showingSuccess: false,
      showingError: false,
      askingInfluenceZone: false,
      askingForRadioValue: false,      
      valor: { selectmap: "traffic" },
      //complaints: false,
      //heatMapcomplaints: false,
      users: false,
      authorities: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      //complaintsList: [],
      clusterOptions: { disableClusteringAtZoom: 11 },
      latLngArray: [],
      geometries: [],
      buffers: [],

      //geojsonVisitor: [],
      //geojsonAuthorities: [],
      //geojsonChappultepec: polygon,
      //visitorMarker: backend_url + "/img/visit-marker.png",
      //authorityMarker: backend_url + "/img/authority-marker.png",
      radioValue: "2",
      radioValueParsed: 0,
      coordsMarker: [],
      markerInfluenceZone: "",
      circleInfluenceZone: "",
      circleInfluenceZoneLayer: "",
      editableLayers: "",
      layerBuffer: "",
      urlBaseMap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    };
  },
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    buttons,
    AlertDialog,
    "v-marker-cluster": Vue2LeafletMarkercluster
  },
  watch: {
    "valor.selectmap": function(val) {
      console.log(val)
      console.log("val")
      if (val === "traffic") {
        console.log(val)
        this.urlBaseMap = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        this.attribution =
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
      } else {
        console.log("Imagery")
        console.log(val)
        this.urlBaseMap =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
        this.attribution =
          "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community";
      }
    },
    complaints: function(val) {
      //Code for complaints button
    },
    heatMapcomplaints: function(val) {
      //code
    },
    users: function(val) {
      //code
    },
    authorities: function(val) {
      //code
    }
  },

  methods: {

    onReady() {
      this.map = this.$refs.map.mapObject;
      //let chapGeojson = L.geoJSON(this.geojsonChappultepec);
      //let chapBounds = chapGeojson.getBounds();
      //this.map.fitBounds(chapBounds);
      // esri.basemapLayer("Topographic").addTo(this.map);
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        // esri.basemapLayer("Topographic").addTo(map);
        this.leafletMap = map;
        this.editableLayers = new window.L.FeatureGroup().addTo(map);
        this.currentNoticeArea = this.editableLayers;

        // console.log(JSON.stringify(this.currentNoticeArea))
        const drawControl = new window.L.Control.Draw({
          //position: "topright",
          position: "topleft",
          draw: {
            polyline: {
              showLength:true
            },
            polygon: {
              showArea:true,
              showLength:true
            },
            rectangle: true,
            circle: false,
            marker: true,
            circlemarker: false
          },
          edit: {
            featureGroup: this.editableLayers
          }
        });

        //agrega conroles de edicion
        const drawControlEditOnly = new window.L.Control.Draw({
          //position: "topright",
          position: "topleft",
          draw: {
            polyline: false,
            polygon: false,
            rectangle: false,
            circle: false,
            marker: false,
            circlemarker: false
          },
          edit: {
            featureGroup: this.editableLayers
          }
        });



        //map.addControl(drawControl);


        drawControl._toolbars.edit.disable =  function () {
          var that = this;
          console.log(this.geometries);
          

          if (!this.enabled()) {
            /* If you need to do something right as the
              edit tool is enabled, do it here right
              before the return */
            return;
          }

          this._activeMode.handler.revertLayers();
          /* If you need to do something when the
            cancel button is pressed and the edits
            are reverted, do it here. */
          console.log("cancel edit")
          console.log(that.editableLayers);


          that.map.removeLayer(this.geometries);

          this.editableLayers.clearLayers();

          L.Toolbar.prototype.disable.call(this);
        };

        this.controlAdd = drawControl;
        this.controlEdit = drawControlEditOnly;


        map.on("draw:created", e => {
          console.log("draw created")
          var layer = e.layer;
          var that = this;
          // console.log(layer)
          //this.noticeArea = layer.toGeoJSON().geometry;
          this.noticeArea = layer.toGeoJSON();
          // console.log("notice area en draw created");
          // console.log(this.noticeArea);
          this.noticeArea.properties = {}

          
          switch(this.noticeArea.geometry.type){
            case "Polygon":
              //this.noticeArea.properties.area = 23
              //this.noticeArea.properties.area = turf.area(this.noticeArea.geometry)/1000000 //en km2
              console.log(stringify(this.noticeArea))
              break;
            case "LineString":
              //this.noticeArea.properties.longitud = 54
              //this.noticeArea.properties.longitud = turf.length(this.noticeArea.geometry, {units: 'kilometers'})
              console.log(stringify(this.noticeArea))
              break;
            case "Point":
              //this.noticeArea.properties.longitud = 54
              //this.noticeArea.properties.position = {lat: this.noticeArea.geometry.coordinates[0], lng: this.noticeArea.geometry.coordinates[1] }
              console.log(stringify(this.noticeArea))
              break;              
          }
       //   console.log(this.noticeArea)
          console.log("editable layers antes de agregar")
          layer.addTo(this.editableLayers);
          console.log(this.editableLayers)
          this.noticeArea.properties.geomID = layer._leaflet_id

          this.geometries.push(this.noticeArea)
          // console.log(this.geometries)
          if (e.layerType == 'marker') {
            // console.log("la geometría es un marcador")
            this.askingInfluenceZone = true;
            this.coordsMarker = Array.from([layer._latlng.lat, layer._latlng.lng])

            // validar que el marcador sea de zona de influencia



            layer.on('dragend', function(event) {
              console.log("dragend al crear marcador");
              that.coordsMarker = Array.from([layer._latlng.lat, layer._latlng.lng])
              that.createInfluenceZoneByDragging(layer._leaflet_id, that.coordsMarker) // pasarle la nueva posicion del marcador
              
              console.log(that.coordsMarker);
            });

          }
          // map.removeControl(drawControl);
 //         drawControlEditOnly.addTo(map);
          //console.log(this.geometries)
        });

        map.on("draw:edited", e => {
          console.log("holaaas");
          let layersEdited = e.layers;
          console.log(e);
          const geomsCopy = JSON.parse(JSON.stringify(this.geometries))
          const geomsCopy2 = JSON.parse(JSON.stringify(this.geometries))
          const buffersCopy = this.buffers.map(function(e){return e;});
          var buffersDeleted = [] // arreglo donde se agregaran los buffers que se borren de marcadores editados
          var geomsEdited = []
          // console.log(layersEdited)

          // console.log("buffers al inicio");
          // console.log(this.buffers)
          // console.log("geometrias al inicio");
          // console.log(JSON.stringify(this.geometries));
          
          layersEdited.eachLayer(layer => {
            console.log(layer);
            geomsCopy.forEach(geom => {
              if( geom.properties.geomID == layer._leaflet_id ) {

                this.noticeArea = ""
                geomsEdited = []

                if( geom.properties.typeGeometry ) {
                  console.log("es buffer o marcador de buffer");
                  if( geom.properties.typeGeometry == "MarkerToBuffer") {
                    // es un marcador de buffer

                    geomsEdited.push(geom)

                    // borra el marcador de buffer del arreglo de geometrias
                    this.geometries = this.geometries.filter( function( g ) {
                      for( let i = 0; i < geomsEdited.length; i++ ) {
                        if( (geomsEdited[i].properties.geomID == g.properties.geomID) 
                        && (geomsEdited[i].properties.typeGeometry == g.properties.typeGeometry) ) {
                          return false;
                        }
                      }
                      return true;
                    });
                    // console.log(JSON.stringify(this.geometries));

                    // reconstruye y agrega nuevamente el marcador de buffer al arreglo de geometrías
                    this.noticeArea = layer.toGeoJSON()
                    this.noticeArea.properties = {}
                    this.noticeArea.properties.geomID = layer._leaflet_id
                    this.noticeArea.properties.typeGeometry = "MarkerToBuffer"
                    this.geometries.push(this.noticeArea);

                    geomsCopy2.forEach(geom2 => {

                      geomsEdited = []

                      if(( geom2.properties.geomID == layer._leaflet_id) && (geom2.properties.typeGeometry == "Buffer")) {
                        
                        geomsEdited.push(geom2)

                        // borra el buffer correspondiente del arreglo de geometrias
                        this.geometries = this.geometries.filter( function( g ) {
                          for( let i = 0; i < geomsEdited.length; i++ ) {
                            if( (geomsEdited[i].properties.geomID == g.properties.geomID) 
                            && (geomsEdited[i].properties.typeGeometry == g.properties.typeGeometry) ) {
                              return false;
                            }
                          }
                          return true;
                        });

                        // borra el buffer del mapa
                        buffersCopy.forEach(bff => {
                          if(geom2.properties.layerBufferID == bff._leaflet_id) {
                            if(map.hasLayer(bff)){
                              buffersDeleted.push(bff)
                              map.removeLayer(bff);
                            } else {
                              console.log("no hay buffer");
                            }
                          }
                        })

                        // borra el buffer del arreglo de buffers
                        this.buffers = this.buffers.filter( function( bff ) {
                          for( let i = 0; i < buffersDeleted.length; i++ ) {
                            if( buffersDeleted[i]._leaflet_id == bff._leaflet_id ) {
                              return false;
                            }
                          }
                          return true;
                        });

                        // reconstruye el buffer y lo agrega a los arreglos de geometrias y buffers
                        var idLayerBuffer = 0;
                        var radioBuffer = geom2.properties.radioValueParsed
                        var point = turf.point([layer._latlng.lng, layer._latlng.lat])
                        this.circleInfluenceZone = turf.buffer( point, radioBuffer, { units: 'kilometers' })
                        this.layerBuffer = L.layerGroup();
                        this.layerBuffer.addTo(map);
                        idLayerBuffer = this.layerBuffer._leaflet_id
                        this.noticeArea = L.geoJson(this.circleInfluenceZone)
                        this.layerBuffer.properties = {}
                        this.layerBuffer.properties.geomID = layer._leaflet_id
                        this.layerBuffer.addLayer(this.noticeArea)
                        this.buffers.push(this.layerBuffer)
                        this.noticeArea = this.noticeArea.toGeoJSON() 

                        this.noticeArea.type = {}
                        this.noticeArea.properties = {}
                        this.noticeArea.geometry = {}
                        this.noticeArea.type = this.noticeArea.features[0].type
                        this.noticeArea.properties = this.noticeArea.features[0].properties
                        this.noticeArea.geometry = this.noticeArea.features[0].geometry
                        this.noticeArea.properties.typeGeometry = ""
                        this.noticeArea.properties.typeGeometry = "Buffer"
                        this.noticeArea.properties.radioValueParsed = radioBuffer
                        this.noticeArea.properties.geomID = layer._leaflet_id  //asigna el mismo id que tiene el marcador
                        this.noticeArea.properties.layerBufferID = idLayerBuffer
                        delete this.noticeArea.features
                        this.geometries.push(this.noticeArea);
                      }
                    }) // <- fin del recorrido de geomsCopy2

                  } else {
                    // es un buffer, no hace nada
                  }
                } else {
                  console.log("no es buffer o marcador de buffer");

                  //borra la anterior geometria del arreglo de geometries
                  this.geometries = this.geometries.filter(function(geom) {
                    return geom.properties.geomID !== layer._leaflet_id; 
                  });

                  //agregar la geometria reconstruida al arreglo de geometries
                  this.noticeArea = layer.toGeoJSON();
                  this.noticeArea.properties = {}
                  this.noticeArea.properties.geomID = layer._leaflet_id
                  console.log(this.noticeArea)
                  this.geometries.push(this.noticeArea)
                }
              } else {
                //no hace nada
                console.log("el id de la geometria es diferente al de esta capa editada");
              }
            });
          });
          // console.log("buffers al final");
          // console.log(this.buffers)
          // console.log("geometrias al final");
          // console.log(JSON.stringify(this.geometries));
        });

        map.on("draw:deleted", e => {
          console.log("draw delete")
        
          var layersDeleted = e.layers //son las capas que se borraron despues de presionar "guardar"
          const geometriesCopy = JSON.parse(JSON.stringify(this.geometries))
          const buffersCopy = this.buffers.map(function(e){return e;});
          var buffersDeleted = [] //arreglo aux, para las capas buffers borrados del mapa
          // console.log(this.buffers);

          layersDeleted.eachLayer( layer => {
            // elimina buffers del mapa y del array de buffers
            for(let i = 0; i< geometriesCopy.length; i++) {
              if( geometriesCopy[i].properties.geomID == layer._leaflet_id ) {
                if( geometriesCopy[i].properties.typeGeometry) {
                  if(geometriesCopy[i].properties.typeGeometry == "Buffer") {
                    buffersCopy.forEach( bff => {
                      if( geometriesCopy[i].properties.layerBufferID == bff._leaflet_id ) { // eliminar el buffer correspondiente del arreglo de geometries y del mapa
                        if ( map.hasLayer(bff) ) {
                          // console.log(bff._leaflet_id); // id de buffers borrados
                          buffersDeleted.push(bff)
                          map.removeLayer(bff)  // remueve el buffer                    
                        }
                      }
                    })
                  }
                }
              }
            }
            
            // console.log(this.buffers);
            
            // Devuelve los elementos del array de geometrias que tengan
            // diferentes IDs de c/u de las capas borradas (foreach no func.)
            this.geometries = this.geometries.filter(function(geom) {
                return geom.properties.geomID !== layer._leaflet_id ; 
            });
            
          })

          // elimina del arreglo de buffers, todos los buffers removidos del mapa
          this.buffers = this.buffers.filter( function( bff ) {
            for( let i = 0; i < buffersDeleted.length; i++ ) {
              if( buffersDeleted[i]._leaflet_id == bff._leaflet_id ) {
                return false;
              }
            }
            return true;
          });

          // console.log(buffersDeleted);

          // console.log(this.geometries.length);
          // console.log(JSON.stringify(this.geometries));
          // console.log(this.buffers);
          // console.log(this.buffers.length);

          this.noticeArea = null;
          map.removeControl(drawControlEditOnly);
          drawControl.addTo(map);
        });
      });


    },
    imgmap: function(click) {
      if (click.mapa == "traffic") {
        this.valor.selectmap = click.mapa;
      } else if (click.mapa == "satellite") {
        this.valor.selectmap = click.mapa;
      }
    },

    createNew(){
      console.log("create newww")
      // console.log(this.buffers);
        
      if(this.buffers.length > 0) {
        this.buffers.forEach(bff => {
          // console.log(bff);
          this.map.eachLayer(function (layer){
            // console.log(layer);
            if(bff._leaflet_id == layer._leaflet_id) {
              // console.log("lo borra");
              layer.remove();
            }
          }); 
        });
          
      }

      this.buffers = []
      this.currentNoticeArea.clearLayers();
      //this.leafletMap.removeControl(this.controlEdit);
     // this.leafletMap.addControl(this.controlAdd);      
      this.geometries = [];
      this.leafletMap.removeControl(this.controlEdit);
      this.leafletMap.addControl(this.controlAdd);
    },

    savedSuccesfully(){
      console.log("se guardo bien")
      this.leafletMap.removeControl(this.controlEdit);
      this.leafletMap.removeControl(this.controlAdd);      
    },  

    askForRadio() {
      this.geometries.forEach(geom => {
        if(this.noticeArea.properties.geomID == geom.properties.geomID) {
          this.noticeArea.properties.typeGeometry = "MarkerToBuffer"
        }
      })
      this.askingInfluenceZone = false;
      this.askingForRadioValue = true;
    },

    createInfluenceZone() {
      var idMarker = this.noticeArea.properties.geomID;
      var idLayerBuffer = 0;
      this.askingForRadioValue = false;   // cierra el modal para introducir el radio
      this.radioValueParsed = Number(this.radioValue);  // radio del círculo en kilometros
      var point = turf.point([this.coordsMarker[1], this.coordsMarker[0]]); // coordenadas para el centro del buffer (círculo)
      this.circleInfluenceZone = turf.buffer( point, this.radioValueParsed, {units: 'kilometers'} ) // forma el círculo
      
      //agregar propiedad radioValueParsed al marcador de buffer
      this.geometries.forEach(geometry => {
        if((this.noticeArea.properties.geomID == geometry.properties.geomID) 
        && (this.noticeArea.properties.typeGeometry == "MarkerToBuffer")) {
          this.noticeArea.properties.radioValueParsed = this.radioValueParsed
        }
      })

      console.log(JSON.stringify(this.geometries))

      this.layerBuffer = L.layerGroup();
      this.layerBuffer.addTo(this.map);
      idLayerBuffer = this.layerBuffer._leaflet_id
      this.noticeArea = L.geoJson(this.circleInfluenceZone)
      this.layerBuffer.properties = {}
      this.layerBuffer.properties.geomID = idMarker
      this.layerBuffer.addLayer(this.noticeArea)
      this.buffers.push(this.layerBuffer)
      console.log(this.buffers.length);
      this.noticeArea = this.noticeArea.toGeoJSON() 

      this.noticeArea.type = {}
      this.noticeArea.properties = {}
      this.noticeArea.geometry = {}
      this.noticeArea.type = this.noticeArea.features[0].type
      this.noticeArea.properties = this.noticeArea.features[0].properties
      this.noticeArea.geometry = this.noticeArea.features[0].geometry
      this.noticeArea.properties.typeGeometry = ""
      this.noticeArea.properties.typeGeometry = "Buffer"
      this.noticeArea.properties.radioValueParsed = this.radioValueParsed
      this.noticeArea.properties.geomID = idMarker  //asigna el mismo id que tiene el marcador
      this.noticeArea.properties.layerBufferID = idLayerBuffer
      delete this.noticeArea.features
      this.geometries.push(this.noticeArea);
      // this.editableLayers = new window.L.FeatureGroup().addTo(this.map);
      // noticeAreaLayer.addTo(this.editableLayers);
      // console.log("editable layers en create influence zone");
      // console.log(this.editableLayers)
    },

    createInfluenceZoneByDragging(idM, coordsM) {
      console.log(idM);
      console.log(coordsM);

      var idMarker = idM;
      var idLayerBuffer = 0;
      var that = this;

      const geomsCopy = JSON.parse(JSON.stringify(that.geometries))
      const geomsCopy2 = JSON.parse(JSON.stringify(that.geometries))
      const buffersCopy = that.buffers.map(function(e){return e;});
      var buffersDeleted = []
      var geomsEdited = []
    
      // this.askingForRadioValue = false;   // cierra el modal para introducir el radio

      that.geometries.forEach(geom => {
        if((geom.properties.geomID == idM) && (geom.properties.typeGeometry) && (geom.properties.typeGeometry == "Buffer")) {
          that.radioValueParsed = Number(geom.properties.radioValueParsed)
        }
      })

      var point = turf.point([coordsM[1], coordsM[0]]); // coordenadas para el centro del buffer (círculo)
      that.circleInfluenceZone = turf.buffer( point, that.radioValueParsed, {units: 'kilometers'} ) // forma el círculo
      

      geomsCopy2.forEach(geom2 => {

        geomsEdited = []

        if(( geom2.properties.geomID == idMarker) && (geom2.properties.typeGeometry) && (geom2.properties.typeGeometry == "Buffer")) {
          
          geomsEdited.push(geom2)

          // borra el buffer correspondiente del arreglo de geometrias
          that.geometries = that.geometries.filter( function( g ) {
            for( let i = 0; i < geomsEdited.length; i++ ) {
              if( (geomsEdited[i].properties.geomID == g.properties.geomID) 
              && (geomsEdited[i].properties.typeGeometry == g.properties.typeGeometry) ) {
                return false;
              }
            }
            return true;
          });

          // borra el buffer del mapa
          buffersCopy.forEach(bff => {
            if(geom2.properties.layerBufferID == bff._leaflet_id) {
              if(that.map.hasLayer(bff)){
                buffersDeleted.push(bff)
                that.map.removeLayer(bff);
              } else {
                console.log("no hay buffer");
              }
            }
          })

          // borra el buffer del arreglo de buffers
          that.buffers = that.buffers.filter( function( bff ) {
            for( let i = 0; i < buffersDeleted.length; i++ ) {
              if( buffersDeleted[i]._leaflet_id == bff._leaflet_id ) {
                return false;
              }
            }
            return true;
          });

        }
      }) // <- fin del recorrido de geomsCopy2

      console.log(JSON.stringify(this.geometries))

      that.layerBuffer = L.layerGroup();
      that.layerBuffer.addTo(that.map);
      idLayerBuffer = that.layerBuffer._leaflet_id
      that.noticeArea = L.geoJson(that.circleInfluenceZone)
      that.layerBuffer.properties = {}
      that.layerBuffer.properties.geomID = idMarker
      that.layerBuffer.addLayer(this.noticeArea)
      that.buffers.push(that.layerBuffer)
      console.log(that.buffers.length);
      that.noticeArea = that.noticeArea.toGeoJSON() 

      that.noticeArea.type = {}
      that.noticeArea.properties = {}
      that.noticeArea.geometry = {}
      that.noticeArea.type = that.noticeArea.features[0].type
      that.noticeArea.properties = that.noticeArea.features[0].properties
      that.noticeArea.geometry = that.noticeArea.features[0].geometry
      that.noticeArea.properties.typeGeometry = ""
      that.noticeArea.properties.typeGeometry = "Buffer"
      that.noticeArea.properties.radioValueParsed = that.radioValueParsed
      that.noticeArea.properties.geomID = idMarker  //asigna el matmo id que tiene el marcador
      that.noticeArea.properties.layerBufferID = idLayerBuffer
      delete that.noticeArea.features
      that.geometries.push(that.noticeArea);

    }
  },

  created() {
    let that = this;
  },
  mounted() {

  },
  computed: {
    styleGeojsonChapp() {
      return () => {
        return {
          color: "#cb2833",
          fill: false
        };
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >


/* .leaflet-draw-toolbar-top {
  margin-top: 300px !important;
} */
/*  .leaflet-draw-toolbar {
 margin-top: 300px !important;
} */

/* .leaflet-draw-section {
  z-index: 10 !important;
} */

.leaflet-draw {
  margin-top: 300px !important;
  z-index: 10 !important;
}  


.leaflet-marker-label {
  width: auto !important;
  height: auto !important;
}

.leaflet-marker-iconlabel {
  background: #fff;
  border-radius: 7px;
  -moz-box-shadow: 0 3px 10px #888;
  -webkit-box-shadow: 0 3px 14px #999;
  box-shadow: 0 3px 10px #888;
  display: block;
  font: 11px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 4px 6px;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  white-space: nowrap;
}
</style>
